export const sizeConfig = {
  small: { iconSize: 16, textType: 'bodySRegular' },
  medium: { iconSize: 24, textType: 'bodyMRegular' },
}
